// Import source styles
import '../scss/app.scss';

// Load External Libraries
import './bootstrap';
import AOS from 'aos';
//import { jarallax, jarallaxVideo } from 'jarallax';
import { Fancybox } from "@fancyapps/ui";

// Local imports
import { validate } from './modules/_validate.mjs';
import { navigationSlider } from "./modules/_carousels.mjs";
//import { scrollSpy } from "./modules/_header.mjs";
import { uspsSlider } from "./modules/_carousels.mjs";
import { pakkettenSlider } from "./modules/_carousels.mjs";
import { voorbeeldenSlider } from "./modules/_carousels.mjs";

document.addEventListener("DOMContentLoaded", function () {
    AOS.init({startEvent: 'load', disable: 'mobile'});
    validate();
    navigationSlider();
    //scrollSpy();
    uspsSlider();
    pakkettenSlider();
    voorbeeldenSlider();

    const formButtons = document.querySelectorAll('.form-submit .btn');
    formButtons.forEach(function (formButton) {
        let text = formButton.textContent;
        let buttonWrapper = document.createElement('span');
        buttonWrapper.innerText = text;
        formButton.textContent = '';
        formButton.appendChild(buttonWrapper);
    });

});

